import React from 'react';
import PropTypes from 'prop-types';
import OverlappingMarkerSpiderfier from 'shims/overlappingMarkerSpiderfier';
import { MAP, MARKER } from 'react-google-maps/lib/constants';

class Spiderfy extends React.PureComponent {
  static contextTypes = {
    [MAP]: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    this.oms = new OverlappingMarkerSpiderfier(this.context[MAP], {
      markersWontMove: true,
      markersWontHide: true,
      legWeight: 0,
    });

    this.markerNodeMounted = this.markerNodeMounted.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  markerNodeMounted(ref) {
    if (!ref) {
      return null;
    }

    const { onSpiderClick } = this.props;
    const marker = ref?.state[MARKER];

    if (!marker) {
      return null;
    }

    const { props: { params: { id, locationId } = {} } = {} } = ref ?? {};

    // Cluster markers (type 2) have no params — do not register with OMS or
    // spider_click will call onMarkerClick(undefined, undefined). Their own
    // onClick handles zoom/cluster expand.
    if (!id || !locationId) {
      return null;
    }

    this.mounted && this.oms.addMarker(marker);

    window.google.maps.event.addListener(marker, 'spider_click', () => {
      if (onSpiderClick) {
        onSpiderClick(id, locationId);
      }
    });
  }

  render() {
    const { children } = this.props;

    return React.Children.map(children, (child) =>
      React.cloneElement(child, { ref: this.markerNodeMounted }),
    );
  }
}

export default Spiderfy;
